import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { IApplicationState } from '../../types/redux';

interface IActivePreviewOfferSourceState extends Pick<IApplicationState, 'previewOffers'> {
  map: Pick<IApplicationState['map'], 'selection'>;
}

/**
 * Выбранное на карте объявление из хранилища превью - для балуна и превью одиночного пина.
 * Пользователь выбрал его явно, поэтому скрытые не отфильтровываются (в отличие от списка selectPreviewOffers).
 */
export function selectActivePreviewOffer(
  state: IActivePreviewOfferSourceState,
): IDailyRentOfferForMobileSite | undefined {
  const activeRealtyId = state.map.selection?.realtyId;

  return state.previewOffers.offers.find(offer => offer.id === activeRealtyId);
}
